import { kioskMutations } from "../mutation-types";

export default {
	namespaced: true,

	state: {
		isKiosk: false
	},

	actions: {
		set( { commit }, val = false ) {
			commit( kioskMutations.SET, val );
		}
	},

	mutations: {
		[kioskMutations.SET]( store, val ) {
			store.isKiosk = val;
		}
	}
};
